import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Badge, Card, Stack} from 'react-bootstrap';
import styles from '../../../users/cards/user-overview-card.module.sass';
import * as React from 'react';

export interface UserOverviewCardProps {
    email: string;
    hasProjectIamPermissions: string;
    hasBuildsClaim: boolean;
    hasPlayersClaim: boolean;
    hasPublisherClaim: boolean;
    hasSessionClaim: boolean;
    active?: boolean;
}

export const UserProjectOverviewCard: FC<UserOverviewCardProps> = observer((props: UserOverviewCardProps) => {

    const name = () => {
        const nameReplace = props.email.substring(0, props.email.lastIndexOf('@'));
        const nameString = nameReplace.replace('.', ' ');
        return nameString !== props.email ? nameString : props.email;
    };

    const iamRole = () => {

        if (props.hasProjectIamPermissions == 'admin')
            return <Badge pill bg="danger" className={styles.iamRoleBadge}><i
                className="fas fa-user-shield"/> Admin</Badge>;
        else if (props.hasProjectIamPermissions == 'viewer')
            return <Badge pill bg="info" className={styles.iamRoleBadge}><i
                className="fas fa-user"/> Viewer</Badge>;
        else
            return null;
    };

    return (
        <Card key={props.email} className={`${styles.userOverviewCard} ${props.active ? 'active' : ''}`}>
            <Card.Body className={styles.cardBody}>
                <Card.Title className={styles.cardTitle}>
                    {name()}
                    {iamRole()}
                </Card.Title>
                <Card.Subtitle className={styles.cardSubtitle}>{props.email}</Card.Subtitle>

                <div className={styles.horizontalListItems}>
                    <Stack direction="horizontal" gap={2}>
                        {props.hasBuildsClaim &&
                            <div className={styles.horizontalListItem}><i className="fas fa-tools"/>
                                <span>Builds</span></div>}
                        {props.hasPlayersClaim &&
                            <div className={styles.horizontalListItem}><i className="fas fa-users"/>
                                <span>Players</span></div>}
                        {props.hasPublisherClaim &&
                            <div className={styles.horizontalListItem}><i className="fas fa-upload"/>
                                <span>Publisher</span></div>}
                        {props.hasSessionClaim &&
                            <div className={styles.horizontalListItem}><i className="fas fa-globe-americas"/>
                                <span>Sessions</span></div>}
                    </Stack>
                </div>
            </Card.Body>
        </Card>
    );
});
